import React, {FC} from 'react';
import {useSelector} from 'react-redux';

import {selectEntityData} from 'modules/data';
import {selectTableEntityData} from 'modules/data/data-selectors';
import {ITableEntityData} from 'modules/data/data-types';
import {EEntityType} from 'shared/constants/entities';
import {ECommonMessages} from 'shared/constants/messages';
import {ERequestType} from 'shared/types/requests';
import {performRequest, showMessage} from 'shared/utils';
import {showMessageFromResponseList} from 'shared/utils/show-message-from-response';
import {useAppSelector} from 'store/config/hooks';
import {TAppState} from 'store/config/types';

import {ActionButton} from '../action-button';
import {ITableActionProps} from '../table-action-types';

const ButtonActionControlRatioComponent: FC<ITableActionProps> = ({
    wrapper,
    meta,
    entityName,
    ...props
}: ITableActionProps) => {
    const rows = useAppSelector(selectTableEntityData(entityName || ''))?.rows;
    const sectionCodeContext: string = String(rows?.slice(0, 1).shift()?.sectionCode);

    const {selectedRowKeys = []} = useSelector(
        (state: TAppState) => (
            selectEntityData(entityName, EEntityType.TABLE)(state) || {}
        ) as ITableEntityData,
    );
    const handleClick = () => {
        if (selectedRowKeys?.length === 0) {
            showMessage({message: ECommonMessages.SELECT_DOCUMENT, isError: true});
        } else if (meta?.referenceUrl) {
            (async () => {
                try {
                    const response = await performRequest({
                        url: meta?.referenceUrl,
                        method: meta?.requestType || ERequestType.POST,
                        params: {sectionCodeContext},
                        data: [...selectedRowKeys],
                    });
                    showMessageFromResponseList(response);
                } catch (e) {
                    console.error(e);
                    showMessageFromResponseList(e.response, true);
                }
            })();
        }
    };

    const Component = wrapper || ActionButton;
    return (
        <Component
            {...props}
            onClick={handleClick}
            actionIcon={meta.actionIcon}
            disabled={!selectedRowKeys.length}
        >
            {meta.actionTitle}
        </Component>
    );
};

export const ButtonActionControlRatio = ButtonActionControlRatioComponent;
